<div class="w-full" data-cy="select-wrapper">
	@let searchOpenAndEnabled = searchEnabled() && dropdownOpen();
	<div
		uiDropdown
		[fullWidth]="fullDropdownWidth()"
		[ignoreTrigger]="searchOpenAndEnabled"
		(openChange)="onDropdownStateChange($event)"
	>
		<ui-select-input
			[placeholder]="translatedPlaceholder()"
			[hasError]="invalid() && touched()"
			[disabled]="disabled()"
			[opened]="dropdownOpen()"
			[value]="currentlySelectedValues() | selectInputText"
			[amountSelected]="multiple() ? selectedOptionsList().length : 1"
			[uiDropdownDisabled]="disabled()"
			[showClearButton]="!multiple() && clearEnabled() && !!value()"
			[inputId]="inputId()"
			[isMultiple]="multiple()"
			[loadedOptionsCount]="options().length"
			[translatedAll]="translatedAll()"
			[optionsComplete]="!parentSearch()"
			[tabindex]="tabindex()"
			(clearSelection)="clearSingleSelection()"
			(keyPressed)="onKeyPressed($event)"
			uiDropdownTrigger
			data-cy="select-dropdown-trigger"
			[searchOpen]="searchOpenAndEnabled"
		>
			<ui-select-search
				[placeholder]="translatedSearchPlaceholder()"
				#searchComponent
				(searched)="onSearch($event)"
				(focusNext)="focusOptionList()"
				class="z-select-search w-full"
			></ui-select-search>
		</ui-select-input>

		<ng-container *uiDropdownContent>
			@if (filteredOptions(); as filteredOptions) {
				<ui-select-option-list
					#optionList
					[options]="filteredOptions"
					[multiEnabled]="multiple()"
					(selected)="onOptionListSelected($event)"
					(scrollEnd)="onScrollEnd()"
					(focusNext)="focusButtons()"
					[selectedValues]="multiple() ? savedValues() : currentlySelectedValues()"
					[customOptionTemplate]="customOptionTemplate()"
					[groupSelectable]="groupSelectable()"
					[customCompareFn]="compareFn()"
					[fieldToCompareBy]="fieldToCompare()"
					[fullWidth]="fullDropdownWidth()"
					[loading]="loading()"
					[translatedNoData]="translatedNoData()"
				>
				</ui-select-option-list>
			}

			@if (savedValues() && maxSelections() && maxSelections()! < savedValues()!.length) {
				<div class="pl-3 pr-3 absolute bottom-10 w-full">
					<ui-notify [text]="translatedMaxSelectionsText()" type="warning"></ui-notify>
				</div>
			}

			@if (multiple()) {
				<div class="flex items-center justify-evenly h-10 border-t border-secondary-300">
					@if (savedValues().length > 0) {
						<ui-select-button
							#deselectButton
							class="grow h-full flex-1"
							[label]="translatedDeselectAll()"
							(buttonClicked)="deselectAll()"
							[attr.data-cy]="'select-button-deselect-all'"
							[disabled]="loading()"
							[tabindex]="0"
						>
						</ui-select-button>
					} @else if (savedValues().length === 0 && selectAllEnabled()) {
						<ui-select-button
							#selectAllButton
							class="grow h-full flex-1"
							[label]="translatedSelectAll()"
							(buttonClicked)="selectAll()"
							[disabled]="loading()"
							[tabindex]="0"
						>
						</ui-select-button>
					}
					<ui-select-button
						#saveButton
						class="grow h-full flex-1"
						[primary]="true"
						[label]="translatedSave() + (maxSelections() ? ' (' + savedValues().length + ')' : '')"
						(buttonClicked)="onSave()"
						[attr.data-cy]="'select-button-save'"
						[disabled]="
							loading() ||
							savedValues().length <= 0 ||
							(maxSelections() !== undefined && savedValues().length > maxSelections()!)
						"
						[tabindex]="0"
					>
					</ui-select-button>
				</div>
			}
		</ng-container>
	</div>
</div>
